<template>
  <div class="navigator">
    <YorkbbsGoogleMap :width="278" :height="140" :position="{ lat, lng } " :detailVisible="detailVisible" :address="address"></YorkbbsGoogleMap>
    <div class="navigator-desc">
      <div class="navigator-address">{{ address }}</div>
      <a class="navigator-link" :href="`https://www.google.com/maps/place/${address}`" target="_blank">
        <i class="yk-navigation"></i>
        <div>到这里去</div>
      </a>
    </div>
  </div>
</template>
<script>
import YorkbbsGoogleMap from '@/common/google-map/google-static-map.vue';
export default {
  name: 'MapNavigator',
  components: { YorkbbsGoogleMap },
  props: { post: Object },
  computed: {
    detailVisible(){
      return this.post.property.showMyDetailAddress == 1;
    },
    address() {     
      return this.post.property.address;
    },
    lat() {
      return this.post.location.lat;
    },
    lng() {
      return this.post.location.lon;
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.navigator {
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 20px;
}
.navigator-desc {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.navigator-address {
  width: 200px;
  line-height: 22px;
}
.navigator-link {
  text-align: center;
  color: #156db6;
  i {
    font-size: 15px;
  }
  div {
    font-size: 12px;
    line-height: 17px;
    text-decoration: underline;
  }
  &:hover {
    opacity: 0.8;
  }
}
</style>
